
import React from 'react';
import { cn } from '@/lib/utils';

interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
  className?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ 
  currentStep, 
  totalSteps, 
  className 
}) => {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className={cn("w-full bg-gray-100 rounded-full h-2", className)}>
      <div 
        className="h-full bg-morgen-gradient rounded-full transition-all duration-500 ease-in-out"
        style={{ width: `${progress}%` }}
      />
      <div className="flex justify-between mt-2 text-xs text-gray-500 font-satoshi">
        <span>Progress: {Math.round(progress)}%</span>
        <span>Step {currentStep} of {totalSteps}</span>
      </div>
    </div>
  );
};

export default ProgressBar;
